import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';
import { ContentPipeService } from '@services/content-pipe/content-pipe.service';
import { HelperService } from '@services/helper/helper.service';

@Pipe({
    name: 'accommodation',
    standalone: false
})

export class AccommodationPipe implements PipeTransform {
  constructor(
    private contentPipeService: ContentPipeService
  ) {
  }

  private static enhanceAccommodationDetail(accommodationContent, data) {
    accommodationContent.teaser = data.introduction || data.textContent;
    accommodationContent.description = data.textContent;
    accommodationContent.website = data.website;
    accommodationContent.seasonTimes = data.seasonTimes;
    if (data.location) {
      accommodationContent.street = data.location.address;
      accommodationContent.city = data.location.city;
      accommodationContent.zip = data.location.zip;
      if (data.location.coordinates) {
        accommodationContent.latitude = data.location.coordinates.latitude;
        accommodationContent.longitude = data.location.coordinates.longitude;
      }
    }
    if (data.contact && data.contact.length) {
      for (const contactVariant of data.contact) {
        if (contactVariant.type === 'phone') {
          accommodationContent.phone = contactVariant.value;
        }
        if (contactVariant.type === 'fax') {
          accommodationContent.fax = contactVariant.value;
        }
        if (contactVariant.type === 'email') {
          accommodationContent.email = contactVariant.value;
        }
      }
    }
    if (data.raw) {
      const raw = JSON.parse(data.raw);
      accommodationContent.isSuperior = raw.isClassificationSuperior;
      if (typeof accommodationContent.isSuperior === 'string' && !isNaN(parseInt(accommodationContent.isSuperior, 10))) {
        accommodationContent.isSuperior = parseInt(accommodationContent.isSuperior, 10) > 0;
      }
      const fields = ['barrierFreeRoomCount', 'bedCount', 'classificationId', 'doubleRoomCount', 'roomCount', 'singleRoomCount'];
      for (const field of fields) {
        accommodationContent[field] = raw[field];
      }
      accommodationContent.banquetParticipantsMax = raw.banquetParticipantMax;
      accommodationContent.banquetParticipantsMin = raw.banquetParticipantMin;
      accommodationContent.suiteCount = raw.suiteCounte;
      accommodationContent.seminarParticipantsMin = raw.seminarParticipantMin;
      accommodationContent.seminarParticipantsMax = raw.seminarParticipantMax;
      accommodationContent.isGarni = raw.isClassificationGarni;
    }
    accommodationContent.openingHours = HelperService.initOpeningData(data) || accommodationContent.openingHours;
    if (!!data?.openingHours?.disabled) {
      delete accommodationContent.openingHours;
    }
    return accommodationContent;
  }

  transform(entry: any): any {
    if (!entry || !entry.content) {
      return null;
    }

    const accommodationEntry: any = new Models.AccommodationEntry();
    let media = this.contentPipeService.getMedia(entry);

    media = _.orderBy(media, ['type'], ['asc']);

    let accommodationContent = { sourceId: entry._id, title: entry.title, media };

    if (entry.content) {
      accommodationContent = AccommodationPipe.enhanceAccommodationDetail(accommodationContent, entry.content);
    }

    accommodationEntry.populateFromJSON(accommodationContent);
    accommodationEntry.contentType = 'accommodation';

    return accommodationEntry;
  }
}
